import { render } from "./index.vue?vue&type=template&id=b988bb88"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/app-review-settings-add/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b988bb88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b988bb88', __exports__)) {
    api.reload('b988bb88', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b988bb88", () => {
    api.rerender('b988bb88', render)
  })

}


export default __exports__